import { Icon } from "@material-ui/core";
import { ArrowBackOutlined } from "@mui/icons-material";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import LinkOutlinedIcon from "@mui/icons-material/LinkOutlined";
import LiveHelpOutlinedIcon from "@mui/icons-material/LiveHelpOutlined";
import {
  Alert,
  AlertTitle,
  Autocomplete,
  Button,
  CardContent,
  CardHeader,
  Chip,
  Grid,
  IconButton,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { GridSearchIcon } from "@mui/x-data-grid";
import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "../../../../../hooks/useQuery";

const AppGuid = ({
  title = "Guide d'utilisation",
  description = "Retrouvez ici les étapes pour utiliser le plateforme de manière efficace",
  maj = "03 Mars 2026",
  typeGuide = "public",
}) => {
  const searchInputRef = useRef(null);
  const [guides, setGuides] = React.useState([]);
  const [filteredGuides, setFilteredGuides] = React.useState([]);
  const [keywords, setKeywords] = React.useState([]);
  const navigate = useNavigate();
  const query = useQuery();
  const [filter, setFilter] = React.useState({
    search: "",
    typedKeywords: "",
  });

  const loadedGuids = () => {
    const context = window.location.pathname.includes("administration")
      ? require.context(`../data/admin/fr`, false, /\.json$/)
      : require.context(`../data/public/fr`, false, /\.json$/);

    // const context = require.context("../data/"+typeGuide+"/fr", false, /\.json$/);
    console.log("context", context.keys());
    return context.keys().map((key) => ({
      name: key.replace("./", ""),
      src: context(key),
    }));
  };

  const handleGetKeyWords = () => {
    let k = [];
    /*  guides.forEach((guide) => {
      console.log("guide:", guide);
      k.push(guide.src.title);
      // k.push(...guide.src.steps.map((step) => step.title));
    }); */
    k = guides.map((guide) => guide.src.title);

    return k;
  };

  const filterGuides = (guides) => {
    if (!query.get("search") || query.get("search").trim() === "")
      setFilteredGuides(guides);
    else
      setFilteredGuides(
        guides.filter((guide) => {
          const searchTerms = query.get("search").toLowerCase().split(" ");
          return searchTerms.every(
            (term) =>
              guide.src.title.toLowerCase().includes(term) ||
              guide.src.description.toLowerCase().includes(term) ||
              Array.from(guide.src.keywords).some((kw) =>
                kw.toLowerCase().includes(term),
              ),
          );
        }),
      );
  };

  useEffect(() => {
    if (guides || query.get("search")) filterGuides(guides);
  }, [query.get("search"), guides]);

  useEffect(() => {
    let a = loadedGuids();
    console.log("a", a);
    let kw = handleGetKeyWords();
    setGuides(a);
    setKeywords(kw);
  }, []);
  return (
    <>
      <Grid container display={"flex"} justifyContent={"center"}>
        <Grid item xs={12} mb={1}>
          <Button
            size="small"
            variant="outlined"
            onClick={(e) => navigate("/")}
            title="Retour"
            sx={{textTransform: "capitalize"}}
            startIcon={<ArrowBackOutlined />}
          >
            retour
          </Button>
        </Grid>
        <Grid
          item
          xs={12}
          height={"100%"}
          display={"flex"}
          alignItems={"center"}
          color={"GrayText"}
          sx={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          }}
        >
          {/* <img src="/assets/images/guide_admin.png" alt="guide admin" style={{width:"100%"}} /> */}
          <CardHeader
            variant="h4"
            mt={2}
            mb={2}
            sx={{ color: "white", minHeight: "25vh" }}
            title={
              <Grid>
                {/*  <Chip
                  variant="outlined"
                  label="Guide d'utilisation"
                  sx={{ mb: 2, color: "white", fontSize: "20px" }}
                /> */}
                <Grid
                  container
                  display={"flex"}
                  alignItems={"flex-end"}
                  gap={1}
                >
                  <Icon
                    component={LiveHelpOutlinedIcon}
                    sx={{ fontSize: "40px", color: "white", mt: 1 }}
                  />
                  <Typography variant="h4">
                    {title || "Guide d'utilisation"}
                  </Typography>
                </Grid>
              </Grid>
            }
            // titleTypographyProps={{}}
            subheaderTypographyProps={{ variant: "caption", ml: 1 }}
            subheader={
              <Grid
                container
                display={"flex"}
                flexDirection={"column"}
                spacing={2}
                gap={1}
              >
                <Grid item>
                  <Typography color={"rgb(245, 232, 245)"}>
                    {description ||
                      "Retrouvez ici les étapes pour utiliser le plateforme de manière efficace"}
                  </Typography>
                </Grid>
                <Grid item>
                  <Chip
                    variant="outlined"
                    label={
                      <Grid
                        container
                        display={"flex"}
                        alignItems={"flex-end"}
                        gap={1}
                      >
                        <Icon
                          component={CalendarMonthOutlinedIcon}
                          sx={{ color: "white" }}
                        />
                        <Typography variant="caption">
                          {`Dernière mise à jour : ${maj || "03 Mars 2026"}`}
                        </Typography>
                      </Grid>
                    }
                    sx={{ color: "white" }}
                  />
                </Grid>
              </Grid>
            }
          />
        </Grid>
        <Grid item xs={12} display={"flex"} mt={3} justifyContent={"center"}>
          <Grid
            item
            xs={12}
            md={6}
            display={"flex"}
            flexDirection={"column"}
            p={2}
          >
            <Autocomplete
              freeSolo
              name="search"
              id="search"
              options={keywords}
              // getOptionKey={(option) => option}
              value={filter.search}
              getOptionLabel={(option) => option || ""}
              onChange={(val) => {
                setFilter((prev) => ({
                  ...prev,
                  search: val ? val.target.innerText : "",
                }));
                if (val.target.innerText)
                  navigate("?search=" + val.target.innerText || "");
                else navigate("?search=");
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  inputRef={searchInputRef}
                  size="small"
                  id="recherche"
                  fullWidth
                  value={filter.search}
                  placeholder="Recherche"
                  onChange={(e) => {
                    setFilter((prev) => ({
                      ...prev,
                      search: e.target.value,
                    }));
                    navigate("?search=" + e.target.value || "");
                  }}
                  slotProps={{
                    input: {
                      ...params.InputProps,
                      startAdornment: (
                        <IconButton
                          title="Rechercher"
                          onClick={() =>
                            navigate("?search=" + searchInputRef.current.value)
                          }
                        >
                          <GridSearchIcon />
                        </IconButton>
                      ),
                    },
                  }}
                />
              )}
            />
          </Grid>
        </Grid>
        <Grid
          container
          display={filteredGuides.length === 0 ? "flex" : "none"}
          mt={6}
        >
          <Grid item xs={12} display={"flex"} justifyContent={"center"}>
            <Alert severity="info" variant="outlined">
              <AlertTitle>
                <b>Aucun résultat trouvé</b>
              </AlertTitle>
              Essayez de modifier votre recherche ou de vérifier l'orthographe
              des mots-clés.
            </Alert>
          </Grid>
        </Grid>
        <Grid container>
          <Paper
            sx={{ width: "100%", borderLeft: "3px solid #5af" }}
            elevation={2}
          >
            <Grid
              item
              xs={12}
              flexGrow={1}
              display={filteredGuides.length > 0 ? "flex" : "none"}
              flexWrap={"wrap"}
              p={2}
            >
              <CardHeader
                title={<Stack>Sommaire</Stack>}
                titleTypographyProps={{ variant: "h5" }}
                subheader={
                  <Grid
                    container
                    display={"flex"}
                    // flexDirection={"column"}
                    gap={1}
                    mt={2}
                  >
                    {guides.map((item, index) => (
                      <Chip
                        key={index}
                        variant="outlined"
                        // sx={{ color: "white", m: 1 }}
                        color="info"
                        label={
                          <Typography variant="body2" component={"div"}>
                            <a
                              style={{ textDecoration: "none" }}
                              href={"#titre" + item.src.title}
                            >
                              {item.src.title}
                            </a>
                          </Typography>
                        }
                      />
                    ))}
                  </Grid>
                }
              />
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={12} mt={3}>
          {filteredGuides.map((item, index) => (
            <Paper
              key={index}
              id={"titre" + item.src.title}
              sx={{ borderRadius: "1%", mb: 5 }}
              elevation={2}
            >
              <Grid borderRadius={"2%"}>
                <CardHeader
                  avatar={
                    <Chip
                      sx={{ color: "white" }}
                      color="info"
                      label={index + 1}
                    />
                  }
                  title={
                    <Typography
                      variant="h5"
                      dangerouslySetInnerHTML={{
                        __html: item.src.title,
                      }}
                    />
                  }
                  action={
                    <IconButton
                      sx={{ color: "white" }}
                      disabled={!item.src.link}
                      onClick={() => {
                        navigate(process.env.PUBLIC_URL + "/" + item.src.link);
                      }}
                    >
                      <LinkOutlinedIcon sx={{ color: "white" }} />
                    </IconButton>
                  }
                  titleTypographyProps={{ variant: "h5" }}
                  sx={{
                    color: "white",
                    background:
                      "linear-gradient(135deg, #051c81 0%, #0f0cd1 100%)",
                    // borderRadius: "2.5% 2.5% 0 0",
                  }}
                />
                <CardContent>
                  <Grid
                    container
                    display={"flex"}
                    flexDirection={"column"}
                    gap={2}
                    p={2}
                  >
                    <Alert
                      severity="info"
                      variant="outlined"
                      title="Description"
                    >
                      <AlertTitle>
                        <b>Description</b>
                      </AlertTitle>
                      <Typography
                        component={"div"}
                        dangerouslySetInnerHTML={{
                          __html: item.src.description,
                        }}
                      />
                    </Alert>
                  </Grid>
                  {item.src.steps.map((step, index) => (
                    <Grid
                      key={index}
                      container
                      display={"flex"}
                      alignItems={"center"}
                      mb={2}
                    >
                      <Grid item xs={12}>
                        <CardHeader
                          title={
                            <Typography
                              variant="h5"
                              dangerouslySetInnerHTML={{ __html: step.title }}
                            />
                          }
                          subheader={
                            <>
                              <Typography
                                component={"div"}
                                dangerouslySetInnerHTML={{
                                  __html: step.description,
                                }}
                              />
                              <Grid
                                container
                                justifyContent={"center"}
                                mt={2} /* border={"1px solid #4916e1af"} */
                              >
                                {step.pj && (
                                  <img
                                    src={process.env.PUBLIC_URL + step.pj}
                                    alt="Step illustration"
                                    style={{
                                      maxWidth: "100%",
                                      height: "auto",
                                      marginTop: "10px",
                                    }}
                                  />
                                )}
                              </Grid>
                            </>
                          }
                        />
                      </Grid>
                    </Grid>
                  ))}
                </CardContent>
              </Grid>
            </Paper>
          ))}
        </Grid>
      </Grid>
    </>
  );
};

export default AppGuid;
